// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"OpeningHoursModal__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/OpeningHoursModal/OpeningHoursModal.scss
 ** module id = 926
 ** module chunks = 1
 **/